/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { BannerAlertType } from "sirius-platform-support-library/shared/banner-alerts/banner-alert-type";
import { ServicePageNotificationsType } from "../../models/service-page-notification.model";
import { ActionTypeEnum } from "sirius-platform-support-library/models/common";
import { ActionType } from "../../models/action-type.model";

export type PatternTypes = "full" | "long" | "medium" | "short" | undefined;

export const BANNER_KEY = "BANNERS";
export const TEXT_KEY = "TEXT";
export const ACTION_KEY = "ACTION";
export const LINK_KEY = "LINK";
export const BANNER_TEXT = "{{BANNERS.TEXT}}";
export const BANNER_START_FROM = "{{BANNERS.STARTS_FROM}}";
export const BANNERS_TO = "{{BANNERS.TO}}";
export const BANNERS_ACTIONS_LINK = "{{BANNERS.ACTION.LINK}}";
export const BANNERS_ACTIONS_TEXT = "{{BANNERS.ACTION.TEXT}}";
export const ENABLE_BACKUP_ALERT = "ENABLE_BACKUP_ALERT";

export const TypeAndIconBannerMap: {
  [key: string]: {
    type: BannerAlertType;
    iconType: string;
  };
} = {
  [ServicePageNotificationsType.INFORMATIONAL]: {
    type: BannerAlertType.INFO,
    iconType: "info-standard",
  },
  [ServicePageNotificationsType.ERROR]: {
    type: BannerAlertType.ERROR,
    iconType: "error-standard",
  },
  [ServicePageNotificationsType.WARNING]: {
    type: BannerAlertType.WARNING,
    iconType: "warning-standard",
  },
};

export const ActionMapper: {
  [key: string]: ActionTypeEnum;
} = {
  [ActionType.LINK]: ActionTypeEnum.URL,
  [ActionType.NONE]: ActionTypeEnum.UNKNOWN,
  [ActionType.NULL]: ActionTypeEnum.UNKNOWN,
};

export const LocaleBackupAlerts = {
  en_US:
    "We're experiencing intermittent issues across TechDirect services and we're working to resolve them now. Please try again later.",
  de_DE:
    "Wir haben zeitweilige Probleme bei TechDirect-Services und arbeiten jetzt an deren Lösung. Bitte versuchen Sie es später erneut.",
  es_ES:
    "Los servicios de TechDirect están teniendo problemas intermitentes y estamos trabajando para resolverlos. Vuelva a intentarlo más tarde.",
  fr_FR:
    "Les services TechDirect rencontrent des problèmes intermittents et nous travaillons à leur résolution. Veuillez réessayer ultérieurement.",
  it_IT:
    "Abbiamo riscontrato problemi intermittenti sui servizi TechDirect e stiamo lavorando per risolverli. Riprova in seguito.",
  ja_JP:
    "TechDirectサービス全体で断続的な問題が発生しており、現在解決に向けて取り組んでいます。後でもう一度お試しください。",
  ko_KR:
    "TechDirect 서비스 전반에서 간혹 문제가 발생하고 있어 현재 문제 해결 중입니다. 나중에 다시 시도하십시오.",
  pt_PT:
    "Estamos enfrentando problemas intermitentes nos serviços TechDirect e estamos trabalhando para resolvê-los. Tente novamente mais tarde.",
  ru_RU:
    "У нас периодически возникают проблемы со службами TechDirect, и мы сейчас работаем над их решением. Повторите попытку позже.",
  zh_CN: "TechDirect 服务当前正间歇性出现问题，我们正在努力解决。请稍后重试。",
  zh_TW:
    "我們在 TechDirect 服務中遇到間歇性問題，現在正努力解決這些問題。請稍後再試。",
};
